import {
  StateRule,
  StateTransitionOptions,
  StateResult,

  StateNavigationAction,
  Transition,
  addPreviousNext,
  // eslint-disable-next-line
  addPrevious,
  // eslint-disable-next-line
  addNext,  
} from "../StateInterfaces";
import { NavigatonIcons } from "@/business/application/NavConst";
import {Commands} from "@/business/application/commands/Command";
import { BaseState } from "../StateMachine";
import { StateHunting } from "./StateHunting";
import { StateWildBook } from "./StateWildBook"



export class StateWildBookEntry extends BaseState {

  private mainState = "WildBookEntry";
  private startState = "WildBookEntry"
  private static transitions: Transition[] = [];  
  private static callingState : StateResult = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''}
  private isDirectionNext = false

  // Diesen Status setzen wenn es auf den Main-Status zurück geht. 
  private isDirectionPreviousParent = true

  public constructor() {
    super()    
    
  }


  
  public next(rule: StateRule, options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, false, this.mainState);
  }
  public previous(rule: StateRule,options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, true, this.mainState);
  }

  protected calculateState(rule: StateRule,options: StateTransitionOptions, isPrevious: boolean, mainState: string): StateResult {
    this.isDirectionNext = ! isPrevious
    const context = this.getContext()
    const currentResultState = context.getCurrentResultState();

    if ( isPrevious && this.isDirectionPreviousParent && currentResultState.newState === "WildBookEntry") {
      return this.checkResultState(StateWildBookEntry.callingState);
    }

    let condition = this.calculateBusinessConditions(rule,this.getContext().getCurrentState());
    if ( condition === undefined || condition === null || condition.length === 0 || condition === "") {
      if ( currentResultState.newState === "WildBookEntry"  && this.isDirectionNext ) {
        condition = "WildBookEntryLocation";
      }
      if ( currentResultState.newState === "WildBookEntryLocation"  && this.isDirectionNext && condition === "" ) {
        condition = "WildBookEntryHunting";
      }
      if ( currentResultState.newState === "WildBookEntryHunting"  && this.isDirectionNext && condition === "" ) {
        condition = "WildBookEntryAnimal";
      }
      if ( currentResultState.newState === "WildBookEntryAnimal"  && this.isDirectionNext && condition === "") {
        condition = "WildBookEntryAnimalExtension";
      }
      if ( currentResultState.newState === "WildBookEntryAnimalExtension"  && this.isDirectionNext && condition === "") {
        condition = "SaveAndJump";
      }


      if ( currentResultState.newState === "WildBookEntryAnimalExtension"  && !this.isDirectionNext && condition === "") {
        condition = "WildBookEntryAnimal";
      }
      if ( currentResultState.newState === "WildBookEntryAnimal"  && !this.isDirectionNext && condition === "") {
        condition = "WildBookEntryHunting";
      }
      if ( currentResultState.newState === "WildBookEntryHunting"  && !this.isDirectionNext && condition === "") {
        condition = "WildBookEntryLocation";
      }

      if ( currentResultState.newState === "WildBookEntryLocation"  && !this.isDirectionNext && condition === "") {
        condition = "WildBookEntry";
      }
    }

    if ( this.isDirectionNext ) {
      const nextTransition = this.getTransitions().filter(row => { 
        if ( row.nav !== StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(nextTransition[0], options);
    } else {
      const previosTransition = this.getTransitions().filter(row => { 
        if ( row.nav === StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(previosTransition[0], options);
    }
  }


  protected calculateBusinessConditions(rule: StateRule, resultState: StateResult): string {
    if ( rule.conditions === undefined || rule.conditions === null || rule.conditions.length === 0 ) {
      return "";
    }

    if (rule.conditions.length == 1) {
      return rule.conditions[0].value;
    }

    return "";
  }


  private getCallingState(condition: string) : StateResult {
    if (this.isDirectionPreviousParent) { 
      // Condition = "Login"
      StateWildBookEntry.callingState.newMainState = condition
      StateWildBookEntry.callingState.newState = condition
      StateWildBookEntry.callingState.routeName = condition
      StateWildBookEntry.callingState.oldMainState = this.mainState
      StateWildBookEntry.callingState.oldState = this.startState

      return StateWildBookEntry.callingState;
    }
     StateWildBookEntry.callingState = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''};
     return StateWildBookEntry.callingState;
  }

  public getStartTransition(condition: string) : StateResult {
    StateWildBookEntry.transitions = []
    this.getTransitions()
    if ( condition !== this.mainState) {
      StateWildBookEntry.callingState = this.getCallingState(condition);
    }
    const t = this.getTransitions()[0];
    return this.getTransition(t);
  }



  protected checkState( transition: Transition, options: StateTransitionOptions): StateResult {
    let newMainState = this.mainState    
    let skip = false
    const newResultState: StateResult = this.getTransition(transition)

    if ( this.isDirectionPreviousParent && !this.isDirectionNext) {
      newMainState = StateWildBookEntry.callingState.oldMainState
    }
    else {      
      newMainState = transition.newMainState
      if (transition.newState == "")
        skip = true
    }

    if (!options.lookahead && transition.newState != "") {
      return this.changeResultState(transition.newMainState, newResultState);
    }
    return newResultState;
  }

  private checkResultState( stateResult: StateResult ) : StateResult {  
    const newResultState = StateWildBookEntry.callingState;    
    return this.changeResultState(stateResult.newMainState, newResultState);      
  }

  private changeResultState(newMainStatePar: string , compResultState: StateResult) : StateResult {
    let newState: any;
    switch (newMainStatePar) {
        case "Hunting":
          newState = new StateHunting();
          compResultState = newState.getStartTransition("Hunting")
          this.getContext().transitionTo(newState,compResultState);
          break;
        case "WildBook":
          newState = new StateWildBook();
          compResultState = newState.getStartTransition("Hunting")
          this.getContext().transitionTo(newState,compResultState);
          break;                         
        default:          
          this.getContext().transitionTo(new StateWildBookEntry(), compResultState);        
    }
    return compResultState;
  }




  //-- Sammlung aller Statusübergänge
  public getTransitions(): Transition[] {
    if (StateWildBookEntry.transitions.length === 0) {

      //__ Start State egal von welcher Stufe aus
      //
      let t: Transition = { mainState: "*", newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: "*", newState: this.startState, condition: "Start"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBookEntryLocation", condition: "WildBookEntryLocation"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBookEntryHunting", condition: "WildBookEntryHunting"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBookEntryAnimal", condition: "WildBookEntryAnimal"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBookEntryAnimalExtension", condition: "WildBookEntryAnimalExtension"};      
      t = addPrevious( t, Commands.PreviousPage )
      //t = addPreviousNext( t, Commands.PreviousPage , Commands.RuleDynamicSave )
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: "Hunting", nav: StateNavigationAction.Next, oldState: this.startState, newState: "Hunting", condition: "SaveAndJump"};      
      t = addPreviousNext( t, Commands.PreviousPage, Commands.NextPage )
      StateWildBookEntry.transitions.push(t);



      //__ Backward Previous gesetzt
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WildBookEntryAnimalExtension", newState: "WildBookEntryAnimal", condition: "WildBookEntryAnimal"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);
      
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WildBookEntryAnimal", newState: "WildBookEntryHunting", condition: "WildBookEntryHunting"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WildBookEntryHunting", newState: "WildBookEntryLocation", condition: "WildBookEntryLocation"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);

      
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WildBookEntryLocation", newState: "WildBookEntry", condition: "WildBookEntry"};      
      t = addPreviousNext( t, Commands.PreviousPage , Commands.NextPage)
      StateWildBookEntry.transitions.push(t);
      
      


      //__ Save Button
      t = { mainState: this.mainState, newMainState: "WildBook", nav: StateNavigationAction.Next, oldState:this.startState, newState: "WildBook", condition: "WildBook"};      
      t = addNext(t, Commands.PreviousPage);
      StateWildBookEntry.transitions.push(t);

  
     
    }
    return StateWildBookEntry.transitions;
  }
}
